import { render, staticRenderFns } from "./CollectionFilters.vue?vue&type=template&id=5960d6b3&scoped=true&"
import script from "./CollectionFilters.vue?vue&type=script&lang=js&"
export * from "./CollectionFilters.vue?vue&type=script&lang=js&"
import style0 from "./CollectionFilters.vue?vue&type=style&index=0&id=5960d6b3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5960d6b3",
  null
  
)

export default component.exports